import {useQuery, UseQueryOptions} from "react-query";
import Alert from "react-s-alert";
import {
  HubAndSpokeService,
  TemplateField,
} from "../../../services/HubAndSpokeService";

export const useTemplateFieldsQuery = (
  templateName?: string,
  workflowType?: string,
  options?: UseQueryOptions<Array<TemplateField> | undefined>[],
) => {
  return useQuery(
    ["GET_TEMPLATE_FIELDS", templateName, workflowType],
    async () => {
      const {data} = await HubAndSpokeService.getTemplateFields({
        template_name: templateName,
        workflow_type: workflowType,
      });
      return data;
    },
    {
      onError: () => {
        Alert.error("Failed to get template fields.");
      },
      cacheTime: 0,
      enabled: !!templateName,
      ...options,
    },
  );
};
